import {
  PLAN_CLASS_NAME,
  WORKOUT_CLASS_NAME
} from '@gymaholic/packages'
import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import { PAGE_MODEL_CLASS_NAME } from 'models/daos/page/constants'
import { USER_MODEL_CLASS_NAME } from 'models/daos/user/constants'
import { getSectionNameFromClassNameModelUtil } from 'models/utils/get-section-name'
import { getWebsiteUrlEnvironmentUtil } from 'modules/environment/utils'
import { MODEL_KEY } from 'modules/redux/constants/model-key'
import { getDomainMapValueReduxUtil } from 'modules/redux/utils/get-domain-map-value'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import { SECTIONS_NAME } from 'modules/sections/constants/index.cjs'
import { EXERCISE_CLASS_NAME } from 'modules/training/models/exercise/constants'
import { logUtil } from 'packages/src'
import getPathnamePlanUtil from 'modules/plan/redux/utils/get-pathname/index.js'
import getPathnameWorkoutUtil from 'modules/workout/redux/utils/get-pathname/index.js'
import getUrlExerciseUtil from 'modules/exercise/redux/utils/get-url/index.js'

const CLASS_NAME_TO_URL_GETTER = {
  [EXERCISE_CLASS_NAME]: getUrlExerciseUtil,
  [PAGE_MODEL_CLASS_NAME]: getPageUrlModelUtil,
  [WORKOUT_CLASS_NAME]: getPathnameWorkoutUtil,
  [PLAN_CLASS_NAME]: getPathnamePlanUtil,
  [CATEGORY_MODEL_CLASS_NAME]: getCategoryUrlModelUtil,
  [USER_MODEL_CLASS_NAME]: getUserUrlModelUtil
}

function getPageUrlModelUtil (instance) {
  const categories = getValueReduxUtil(instance, 'categories') || []
  const slug = getValueReduxUtil(instance, 'slug')
  const category = categories[0]
  if (category) {
    return `/${getValueReduxUtil(category, 'name')}/${slug}`
  }
  return `/${slug}`
}

function getCategoryUrlModelUtil (instance) {
  if (!instance.section) {
    return '/'
  }
  const section = getValueReduxUtil(
    getValueReduxUtil(instance, 'section'),
    'name'
  )
  if (section === SECTIONS_NAME.HOME) {
    return '/'
  }

  const name = getValueReduxUtil(instance, 'name')
  if (name === 'all') {
    return `/${section}`
  }
  return `/${section}/${name}`
}

function getByPointerUrlModelUtil (instance) {
  const section = getSectionNameFromClassNameModelUtil(instance[MODEL_KEY.CLASS_NAME])
  if (!section) {
    return
  }
  return `/${section}/${getDomainMapValueReduxUtil(instance)}`
}

function getUserUrlModelUtil (instance) {
  const name = getValueReduxUtil(instance, 'name')
  return interpolateRouteUtil(ROUTE_PATH.PROFILE_BY_NAME, { name })
}

/**
 * Gets the instance's full path.
 * @param  {Instance} instance
 * @returns {string}
 */
function getRelativeUrlReduxUtil (instance) {
  if (!instance) {
    return
  }
  const getter = CLASS_NAME_TO_URL_GETTER[instance[MODEL_KEY.CLASS_NAME]]
  if (getter) {
    return getter(instance)
  }
  return getByPointerUrlModelUtil(instance)
}

function getUrlReduxUtil (instance) {
  if (!instance) {
    return
  }
  const pathname = getRelativeUrlReduxUtil(instance)
  if (!pathname) {
    logUtil('getUrlReduxUtil')
      .debug('pathname not defined for instance: ', instance)
  }
  if (!pathname && BROWSER) {
    logUtil('getUrlReduxUtil')
      .debug('default to window.location.href')
    return window.location.href
  }
  return getWebsiteUrlEnvironmentUtil() + pathname
}

export {
  getRelativeUrlReduxUtil,
  getUrlReduxUtil
}
